import { UNBLOCK_WS, UNBLOCK_WS_SUCCESS, UNBLOCK_WS_ERROR} from './actionTypes';

export const unBlockWorkstations = ( ws, token, history) => {
    return {
        type: UNBLOCK_WS,
        payload: { ws, token, history }
    }
}

export const unBlockWorkstationsSuccess = (message) => {
    return {
        type: UNBLOCK_WS_SUCCESS,
        payload: {message}
    }
}

export const unBlockWorkstationsError = (ws) => {
    return {
        type: UNBLOCK_WS_ERROR,
        payload: ws
    }
}
